<ng-container>
  <div class="filter-container" *ngIf="filterCollection.length>0">
    <div class="filter-item" *ngFor="let elem of filterCollection">
      <span class="filter-name">{{elem.header.Label}}</span>
      <span class="filter-close" (click)="resetFilter(elem.header)"></span>
    </div>
    <div class="filter-item" *ngIf="filterCollection.length>0">
      <span class="filter-name filter-reset" (click)="resetFilterAll()">Reset All Filters</span>
    </div>
  </div>
  <div class="nr-normal-table-wrapper">
    <div *ngIf="stickyHeader" [ngClass]="{
        'nr-table-sticky-blue-theme': headerTheme === 'blue',
        'nr-table-sticky-light-blue-theme': headerTheme === 'light-blue',
        'nr-table-sticky-gray-theme': headerTheme === 'gray',
        'nr-table-sticky-deep-gray-theme': headerTheme === 'deep-gray' }">
      <div #stickyHeader class="nr-table" [ngStyle]="{ border: isTableBorder === true ? '1px solid #e7e7e7' : 'none' }"
        [ngClass]="{ 'sticky-header-part': scrollActive }">
        <div class="nr-table-header sticky-header-inner nr-table-light-blue-theme">
          <div class="nr-table-header-cell" [style.width]="header.Width ? header.Width : '100%'"
            *ngFor="let header of columnHeaders">
            <span class="nr-table-header-content"
              [ngClass]="{ 'nr-table-header-content-align-centre': header.CenterAlign == true }">
              <div *ngIf="header.Label=='Checkbox' && checkboxButton">
                <div class="nr-table-body-cell">
                  <div class="main-checkbox-section tablecheckbox">
                    <div>
                      <mat-checkbox [(ngModel)]="checkAll" (change)="onCheckboxAllChange($event.checked)">
                      </mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <span *ngIf="header.Label!='Checkbox'" class="nr-table-header-label"
                [matTooltip]="header.tooltip === undefined ? '' : header.tooltip">
                {{ header.Label }}
              </span>
              <div class="sort-btn" *ngIf="header.IsSortable"
                (click)="updatedSortColumn(header.OrderBy, header.SortOrder)">
                <img src="assets/images/{{header.SortOrder ? header.SortOrder : 'sort-default'}}-light.svg" alt="" />
              </div>
              <div class="nr-table-filter-btn" *ngIf="header.filter" container="body"
                [ngClass]="{'nr-table-filter-only-btn': !header.IsSortable}" [ngbPopover]="filterData"
                #popOver="ngbPopover" [placement]="['bottom-left', 'bottom-right']" [autoClose]="'outside'"
                (click)="popOpen(header)">
                <img src="assets/images/{{header.filterAction ? 'filter_filled': 'filter_empty'}}-light.svg" alt="" />
              </div>
            </span>
            <ng-template #filterData>
              <popover [data]="header">
                <div class="filterContainer">
                  <div *ngIf="header.filterType==='TEXT'">
                    <input type="text" class="form-control" placeholder="Enter a keyword" [(ngModel)]="searchKey"
                      (input)="onInputSearchChange($event.target.value, header)" />
                    <div class="common-button-group filter-btn-div" fxLayoutAlign="center center" fxLayoutGap="15px">
                      <button type="button" class="common-button nr-button-cancel reset-filter"
                        (click)="resetFilter(header)" [disabled]="!header.filterAction">
                        Reset
                      </button>
                      <button type="button" class="common-button nr-button-active reset-filter"
                        (click)="filterColData(searchKey, header)" [disabled]="disableFilterBtn || searchKey==''">
                        Filter
                      </button>
                    </div>
                  </div>
                  <div *ngIf="header.filterType===undefined">
                    <input type="text" class="form-control" placeholder="Enter a keyword" [(ngModel)]="searchKey" />
                    <div class="dropdown-filter" [ngClass]="{'dropdown-filter-min': header.DataField?.length > 1}">
                      <div class="form-check"
                        *ngFor="let val of filterValues[header.DataField] | searchPipe: searchKey">
                        <input class="form-check-input" [(ngModel)]="val.isChecked" (change)="onClickHandler($event)"
                          name="{{val.name}}" type="checkbox" id="{{val.name}}">
                        <label class="form-check-label" for="{{val.name}}"> {{val.name}} </label>
                        <label class="desc-title" *ngIf="val.hasOwnProperty('desc')"> {{val.desc}} </label>
                      </div>
                    </div>
                    <div class="common-button-group filter-btn-div" fxLayoutAlign="center center" fxLayoutGap="15px">
                      <button type="button" class="common-button nr-button-cancel reset-filter"
                        (click)="resetFilter(header)" [disabled]="disableFilterDropdownBtn">
                        Reset
                      </button>
                      <button type="button" class="common-button nr-button-active reset-filter"
                        (click)="filterColData(searchKey, header)" [disabled]="disableFilterDropdownBtn">
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
              </popover>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div #scrollContainer class="scroll-table-wrapper" [ngClass]="{ 'scrollable-table-container': stickyHeader }">
      <div class="nr-table" [ngClass]="{ 'scrollable-table': stickyHeader }" [ngStyle]="{
            border: isTableBorder === true ? '1px solid #dddddd' : 'none',
            'margin-top': stickyHeader ? stickyHeaderHeight : '0px'
          }">
        <div class="nr-table-header nr-table-light-blue-theme">
          <div class="nr-table-header-cell" [style.width]="header.Width ? header.Width : '100%'"
            *ngFor="let header of columnHeaders">
            <span class="nr-table-header-content">
              <span class="nr-table-header-label" [matTooltip]="header.tooltip == undefined ? '' : header.tooltip">
                {{header.Label}}
              </span>
            </span>
          </div>
        </div>
        <div class="nr-table-body">
          <div class="nr-table-row" [ngClass]="{
            'nr-table-row-Active': rowData.Active?.Value == 'Y',
            'nr-table-row-Inactive': rowData.Active?.Value == 'N'}" *ngFor="let rowData of data; index as g"
            [attr.data-group-id]="rowData?.GroupId" [attr.data-parent-id]="rowData?.ParentId"
            [attr.data-row-id]="rowData?.RowId">
            <ng-container *ngIf="groupView; else listview">
              <div class="nr-table-body-cell nr-table-body-grouping-container"
                *ngIf="rowData.GroupId; else groupedData">
                <div class="nr-table-body-cell-grouping" [attr.data-group-id]="rowData.GroupId">

                  <div class="nr-table-body-group-container" [ngClass]="{ 'group-row': rowData.IsExpanded == true }">
                    <div class="nr-table-body-group-content">
                      <span>{{ rowData.GroupTitle }}&nbsp;</span>
                      <span class="nr-table-body-grouping-count">({{ rowData.GroupCount }})</span>
                    </div>
                    <div id="expand-collapse" fxLayoutAlign="end center" fxFlex="10%" class="expand-collapse"
                      (click)="toggleDisplay(rowData.GroupId)">
                      <span *ngIf="isShow[rowData.GroupId]">
                        <mat-icon [inline]="true">keyboard_arrow_up</mat-icon>
                      </span>
                      <span *ngIf="!isShow[rowData.GroupId]">
                        <mat-icon [inline]="true">keyboard_arrow_down</mat-icon>
                      </span>
                      <span *ngIf="header.filter" class="nr-table-filter-btn" [ngbPopover]="filterData"
                        [placement]="['bottom', 'auto']" [autoClose]="'outside'">
                        <mat-icon>filter_alt</mat-icon>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #listview>
              <div *ngIf="radioButton" class="nr-table-body-cell">
                <mat-radio-button (click)="selectRadioButton(rowData)"></mat-radio-button>
              </div>
              <div *ngIf="checkboxButton" class="nr-table-body-cell">
                <div class="main-checkbox-section tablecheckbox">
                  <div>
                    <mat-checkbox [(ngModel)]="rowData.recordId.isChecked"
                      (change)="onCheckboxChange($event.checked, rowData)"></mat-checkbox>
                  </div>
                </div>
              </div>
              <div class="nr-table-body-cell" *ngFor="let cellData of rowData | keyvalue: asIsOrder; index as i"
                [ngClass]="{'position-center': cellData.value?.IsPosition, 'hide': cellData.value?.visible === false }">
                <mat-checkbox [(ngModel)]="cellData.value.Value" *ngIf="cellData.key == 'Checked' && rowCheckbox"
                  (click)="chkBoxValue(rowData)">
                </mat-checkbox>
                <span
                  *ngIf="cellData.value?.IsHyperlink === false && cellData.key !== 'Equipment' && cellData.key !== 'Cat' && cellData.key !== 'Priority'"
                  [style.color]="cellData.value?.Isbadge ? '#585858' : ''"
                  [style.background-color]="cellData.value?.Isbadge ? cellData.value?.badgeColour : '' "
                  [ngClass]="{ 'round-border': cellData.value?.Isbadge == true , 'color-badgefont': (cellData.value.Value > 0 && cellData.value.Value <=19) || (cellData.value.Value >= 50) }"
                  [matTooltip]="cellData.value.title">
                  {{ cellData.value.Value === 0 ? "0" : cellData.value.Value ? cellData.value.Value : "–" }}
                </span>
                <span *ngIf="cellData.key === 'Cat' && cellData.key !== 'FailureDetails' && !removeColor"
                  class="color-category" [ngClass]="cellData.value.Value | lowercase"
                  [matTooltip]="cellData.value.title">
                  <img class="category-icon" src="assets/images/dashboard-cat-{{cellData.value.image}}.svg" alt="">
                </span>
                <span *ngIf="cellData.key === 'Priority'" [style.color]="cellData.value?.Isbadge ? '#585858' : ''"
                  [matTooltip]="cellData.value.title">
                  {{ cellData.value.Value}}
                </span>
                <span *ngIf="cellData.key === 'Equipment'" [style.color]="cellData.value?.Isbadge ? '#585858' : '' "
                  [style.background-color]="cellData.value?.Isbadge ? cellData.value?.badgeColour : '' "
                  [ngClass]="{ 'round-border': cellData.value?.Isbadge == true }" [matTooltip]="cellData.value.title">
                  {{ cellData.value.Value }}
                </span>
                <span *ngIf="cellData.value?.key === 'menu'">
                  <button title="menu-item" mat-icon-button [matMenuTriggerFor]="menu" class="remoutline">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu" class='menuClass'>
                    <ng-container
                      *ngTemplateOutlet="dropDown; context: { $implicit: getMenuItems(cellData.value.Value) }">
                    </ng-container>
                  </mat-menu>
                  <ng-template #dropDown let-items>
                    <ng-container *ngFor="let item of items">
                      <button class="remoutline" mat-menu-item
                        (click)="btnClick(rowData, item?.faultId, item?.title, item?.link, item?.type, item?.dialog);">
                        {{item.title}}
                      </button>
                    </ng-container>
                  </ng-template>
                </span>

                <div class="edit-actions" *ngIf="cellData.value?.key === 'actionItem'">
                  <button class="common-button mr-3"
                    [ngClass]="{'nr-button-secondary-img': item.imagePath,'nr-button-secondary-img': item.text ,' nr-button-secondary' : item.isIcon }"
                    *ngFor="let item of cellData.value.Value"
                    (click)="rowActionHandler(item.actionType, cellData.value.rowData)">
                    <mat-icon *ngIf="item.isIcon && item.iconText">{{item.iconText}}</mat-icon>
                    <img *ngIf="item.isImage && item.imagePath" [src]="item.imagePath" class="imagewidth" alt="" />
                    {{item.text}}
                  </button>
                </div>
                <a *ngIf="cellData.value?.IsHyperlink === true"
                  (click)="navigateToLink($event, cellData.value.RedirectionLink, cellData.value.openInNewTab, cellData.value)"
                  [attr.href]="isProperURL(cellData.value.RedirectionLink) ? cellData.value.RedirectionLink : 'javascript: void(0);'"
                  [ngClass]="{
                      'text-inactive': cellData.value?.IsInactive == true && !cellData.value?.RedirectionLink,
                      'link-enabled': cellData.value?.IsHyperlink == true
                    }" class="non-link">
                  <div class="inline-display"
                    [ngClass]="{ 'nr-has-icon': cellData.value.Icon && !cellData.value.IsDisabled }">
                    <div [ngClass]="{
                          'nr-table-cell-multiline': isMultiLine,
                          'nr-table-cell-singleline': !isMultiLine,
                          'nr-text-color-blue': cellData.value?.TextColor === 'blue',
                          'nr-text-color-green': cellData.value?.TextColor === 'green',
                          'nr-text-color-red': cellData.value?.TextColor === 'red'
                        }" [matTooltipPosition]="'above'" [matTooltip]="cellData.value.Value" appToolTip
                      *ngIf="cellData.value.DataType != 'rag'; else ragStatus">
                      {{ cellData.value.Value }}
                    </div>
                    <div class="nr-icon-container" *ngIf="cellData.value.Icon && !cellData.value.IsDisabled"
                      (click)="actOnAction()">
                      <mat-icon [inline]="true">{{cellData.value.Icon}}</mat-icon>
                    </div>
                  </div>
                  <span class="nr-info-icon" *ngIf="cellData.value.Details && cellData.value.Details != null"
                    [matTooltipPosition]="'above'" [matTooltip]="cellData.value.Details">
                  </span>
                </a>
                <ng-template #ragStatus>
                  <div class="nr-rag-status" [ngClass]="{
                        'nr-status-green': cellData.value.Value === 'green',
                        'nr-status-red': cellData.value.Value === 'red',
                        'nr-status-amber': cellData.value.Value === 'amber'
                      }">
                  </div>
                </ng-template>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="no-record-table" *ngIf="data?.length == 0">No records to display</div>
</ng-container>

<div *ngIf="paginationRequired && data && data.length" class="nr-table-pagination">
  <button class="common-page-buttons" mat-raised-button [disabled]="disableFirst" (click)="updatePage('first')">
    <mat-icon>first_page</mat-icon>
    <span>First</span>
  </button>
  <button class="common-page-buttons" mat-raised-button [disabled]="disableFirst" (click)="updatePage('previous')">
    Previous
  </button>
  <button class="nr-page-number common-page-buttons" mat-raised-button
    [ngClass]="selectedPageIndex === count ? 'highlight' : ''" (click)="selectedPageIndex != count && updatePage(count)"
    *ngFor="let count of pageRange">
    {{count}}
  </button>
  <button class="common-page-buttons" mat-raised-button [disabled]="disableLast" (click)="updatePage('next')">
    Next
  </button>
  <button class="common-page-buttons" mat-raised-button [disabled]="disableLast" (click)="updatePage('last')">
    <span>Last</span>
    <mat-icon>last_page</mat-icon>
  </button>
</div>